module.exports = __webpack_public_path__ + "static/media/noti1.a827b98d.png";